module.exports = require('./config.json');